(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pf-whatsapp-contact"] && !Shopify.designMode) return;
  try {
    const contactLink = document.querySelector(".pf-whatsapp-contact");
  if (contactLink) {
    const observed = new WeakSet();
    let queued = false;
    const sync = () => {
      queued = false;
      const host = document.querySelector("shopify-chat");
      if (!host) return;
      let activator;
      let openDialog = false;
      const visit = (root) => {
        if (!observed.has(root)) {
          observed.add(root);
          new MutationObserver(schedule).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class", "aria-expanded", "open"]});
        }
        activator ||= root.querySelector('[part~="activator"]');
        root.querySelectorAll('[role="dialog"]').forEach(dialog => {
          const box = dialog.getBoundingClientRect();
          if (box.width && box.height) openDialog = true;
        });
        root.querySelectorAll("*").forEach(element => {
          if (element.shadowRoot) visit(element.shadowRoot);
        });
      };
      if (host.shadowRoot) visit(host.shadowRoot);
      contactLink.hidden = openDialog;
      if (!activator || openDialog) return;
      const box = activator.getBoundingClientRect();
      if (!box.width || !box.height) return;
      contactLink.style.bottom = `${Math.max(16, window.innerHeight - box.bottom)}px`;
      contactLink.style.right = `${Math.max(20, window.innerWidth - box.left + 12)}px`;
    };
    function schedule() {
      if (!queued) { queued = true; requestAnimationFrame(sync); }
    }
    window.addEventListener("resize", schedule, {passive: true});
    window.visualViewport?.addEventListener("resize", schedule, {passive: true});
    customElements.whenDefined("shopify-chat").then(schedule);
    customElements.whenDefined("shopify-agent-runtime").then(schedule);
    schedule();
  }
  } catch(e) { console.error(e); }
})();

})();
